import React from 'react';
import styled from 'styled-components';

const Audio = styled.audio`
  height: 2.6rem;
  width: 22rem;
  &::-webkit-media-controls-panel {
    background-color: #1e2230;
  }
`;

const Empty = styled.span`
  color: #64748b;
  font-size: 1.1rem;
`;

/**
 * Inline audio player for a recording URL. Falls back to a muted "—"
 * cell when the URL is missing.
 */
const RecordingPlayer = ({ src }) => {
  if (!src) return <Empty>—</Empty>;
  return (
    <Audio controls preload="none" src={src}>
      <track kind="captions" />
    </Audio>
  );
};

export default RecordingPlayer;
